import {Component, Input} from '@angular/core';

@Component({
    selector: 'wba-versioned-text-block',
    templateUrl: './versioned-text-block.component.html',
    standalone: false
})
export class VersionedTextBlockComponent {

  @Input() wbaAntragVersion: string;

}
